module.exports = __webpack_public_path__ + "img/Unknowns Icon_Down.d0f0908c.svg";